
























import { defineComponent, toRefs, PropType, ref, computed, watch } from '@vue/composition-api';
import {
  AcoFormData,
  ACTION_TYPE,
  AdgroupFormData,
  CampaignFormData,
  CreativeNameGenerateMode,
  FullNormalFormData,
  NormalCreative,
} from '@tt4b/ttam-enums';
import { i18n } from './../../../i18n';
import AdName from './index';
import { getAccountTodayHMS } from '@tt4b/ttam-utils';
import { useStdAccountStore, useCreativeNameValidate } from '@tt4b/ttam-hooks';

const name = 'ttam-ad-name-compose';
export default defineComponent({
  name,
  components: {
    TtamAdName: AdName.TtamAdName,
    TtamAdNameTips: AdName.TtamAdNameTips,
    TtamAdNameAddButton: AdName.TtamAdNameAddButton,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: () => ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit, refs }) {
    const { adgroupData, campaignData, creativeData, createMode, normalCreativeData } = toRefs(props);
    const { adNameValidator } = useCreativeNameValidate();
    const {
      isAco,
      isAllowUseInput,
      isAllowUseGenerate,
      isAllowCloseGenerate,
      isCurrentUsedMaterial,
      isDisabledUseGenerateBtn,
      isAllowChange,
    } = AdName.useAdNameIs({
      adgroupData,
      campaignData,
      creativeData,
      createMode,
      normalCreativeData,
    });
    const _creativeName = computed({
      get: () => creativeData.value.creativeName || '',
      set: (val: string) => {
        emit('creative-name-change', val);
      },
    });
    // const { isDisabledCreative } = useCreativeFormGet();
    const isDisabledCreative = ref(false);
    const tagContent = computed(() =>
      isAco.value
        ? i18n.t('module_use_aco_auto_generate_creative_name_label_text')
        : i18n.t('module_use-auto-generate_creative_name_label_text'),
    );

    const setCreativeNameMode = (mode: CreativeNameGenerateMode) => {
      if (!isAllowChange(mode)) {
        throw new Error('Current creative is not allowed to change this mode');
      }
      emit('creative-name-model-change', mode);
    };

    const toggleCreativeNameModel = () => {
      const creativeNameModel = computed(() => creativeData.value.creativeNameModel);
      const creativeName = computed(() => creativeData.value.creativeName);
      if (creativeNameModel.value !== CreativeNameGenerateMode.Input) {
        setCreativeNameMode(CreativeNameGenerateMode.Input);
        const { timezone } = useStdAccountStore();
        if (isAco.value && !creativeName.value) {
          emit('creative-name-change', getAccountTodayHMS(timezone.value));
        }
        return;
      }
      if (isAco.value) {
        emit('creative-name-change', '');
      }
      setCreativeNameMode(CreativeNameGenerateMode.MaterialAndInput);
    };

    watch(_creativeName, val => {
      if (val) {
        refs.form?.validate('');
      }
    });
    return {
      name,
      adNameValidator,
      isAllowUseGenerate,
      isAllowCloseGenerate,
      isCurrentUsedMaterial,
      isAllowUseInput,
      isDisabledUseGenerateBtn,
      isDisabledCreative,
      tagContent,
      _creativeName,
      toggleCreativeNameModel,
    };
  },
});
